/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled, { css } from 'styled-components';

export const WrapperWithOverlay = styled.section<{
  $overlayed: boolean;
}>`
  position: relative;

  ${({ $overlayed }) =>
    $overlayed &&
    css`
      &:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        background-color: rgba(255, 255, 255, 0.85);
      }
    `}
`;
